import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

const GET_ANALYTICS_LIST = `analytics`;

export const FetchAnalyticsList = createAsyncThunk(
  "FetchAnalyticsList",
  async ({ page, limit, start, end }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      let url =`${GET_ANALYTICS_LIST}?page=${page}&limit=${limit}`
      if(start&& end){
        url += `&start=${start}&end=${end}`
      }
      const response = await customAxios('application/json', dispatch).get(url);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);



